export default {
  startPlus: {
    title: 'Plus Support',
    phone: {
      label: 'U.S.: ',
      display: '888.570.6180',
      link: 'tel:18885706180',
    },
    phone2: {
      label: 'Outside U.S.: ',
      display: '818.860.7770',
      link: 'tel:18188607770',
    },
    email: {
      label: 'U.S.: ',
      display: 'plus.support@castandcrew.com',
      link: 'mailto:plus.support@castandcrew.com',
    },
    email2: {
      label: 'Vancouver: ',
      display: 'info_vancouver@castandcrew.com',
      link: 'mailto:info_vancouver@castandcrew.com',
    },
    email3: {
      label: 'Toronto: ',
      display: 'info_toronto@castandcrew.com',
      link: 'mailto:info_toronto@castandcrew.com',
    },
  },
  usa: {
    title: 'Plus Support',
    phone: {
      label: 'U.S.: ',
      display: '818.860.7770',
      link: 'tel:18188607770',
    },
    email: {
      label: 'U.S.: ',
      display: 'plus.support@castandcrew.com',
      link: 'mailto:plus.support@castandcrew.com',
    },
  },
  canada: {
    title: 'Plus Support',
    phone: {
      label: 'Canada: ',
      display: '416.324.9748',
      link: 'tel:14163249748',
    },
    email: {
      label: 'Canada: ',
      display: 'plus.support@castandcrew.com',
      link: 'mailto:plus.support@castandcrew.com',
    },
  },
  etc: {
    title: 'ETC Support',
    phone: {
      label: 'U.S.: ',
      display: '818.480.4400',
      link: 'tel:18184804400',
    },
    email: {
      label: 'U.S.: ',
      display: 'etcsupport@capspayroll.com',
      link: 'mailto:etcsupport@capspayroll.com',
    },
    email2: {
      label: 'Vancouver: ',
      display: 'info_vancouver@castandcrew.com',
      link: 'mailto:info_vancouver@castandcrew.com',
    },
    email3: {
      label: 'Toronto: ',
      display: 'info_toronto@castandcrew.com',
      link: 'mailto:info_toronto@castandcrew.com',
    },
  },
  helpDesk: {
    title: 'Employee Help Desk',
    subHeader: 'Cast & Crew',
    phone: {
      label: 'U.S.: ',
      display: '888.570.4650',
      link: 'tel:18885704650',
    },
    phone2: {
      label: 'Outside U.S.: ',
      display: '818.659.6455',
      link: 'tel:18186596455',
    },
    email: {
      label: 'U.S.: ',
      display: 'employeehelpdesk@castandcrew.com',
      link: 'mailto:employeehelpdesk@castandcrew.com',
    },
    email2: {
      label: 'Vancouver: ',
      display: 'info_vancouver@castandcrew.com',
      link: 'mailto:info_vancouver@castandcrew.com',
    },
    email3: {
      label: 'Toronto: ',
      display: 'info_toronto@castandcrew.com',
      link: 'mailto:info_toronto@castandcrew.com',
    },
  },
  mediaServices: {
    title: 'Media Services',
    phone: {
      label: 'U.S.: ',
      display: '310.254.1702',
      link: 'tel:13102541702',
    },
    email: {
      label: 'U.S.: ',
      display: 'crewportalhelp@mediaservices.com',
      link: 'mailto:crewportalhelp@mediaservices.com',
    },
  },
  payrollTax: {
    email: {
      display: 'payroll_tax@castandcrew.com',
      link: 'mailto:payroll_tax@castandcrew.com',
    },
  },
  capsTax: {
    email: {
      display: 'tax@capspayroll.com',
      link: 'mailto:tax@capspayroll.com',
    },
  },
  products: ['MyCast&Crew', 'Start+', 'Hours+', 'Cast & Crew Studio', 'ETC'],
  reasons: [
    'Token expired',
    "Can't log in",
    "Got an invite and it's not working",
    "Don't remember my username",
    'Direct deposit',
    'Multi-factor Authentication (MFA)',
    'Incomplete profile',
    'Other',
  ],
};
